import { ResultDir } from '@alilc/lowcode-types';
import { IProjectTemplate } from '../../../../../types';
import { generateStaticFiles } from './static-files';

const normalTemplate: IProjectTemplate = {
  slots: {
    components: {
      path: ['src', 'components'],
    },
    pages: {
      path: ['src', 'pages'],
    },
    router: {
      path: ['src'],
      fileName: 'routes',
    },
    entry: {
      path: ['src'],
      fileName: 'index',
    },
    constants: {
      path: ['src'],
      fileName: 'constants',
    },
    utils: {
      path: ['src'],
      fileName: 'utils',
    },
    i18n: {
      path: ['src'],
      fileName: 'i18n',
    },
    globalStyle: {
      path: ['src'],
      fileName: 'globalStyle',
    },
    htmlEntry: {
      path: ['public'],
      fileName: 'index',
    },
    packageJSON: {
      path: [],
      fileName: 'package',
    },
    menuData: {
      path: ['src'],
      fileName: 'menuData',
    },
  },

  generateTemplate(): ResultDir {
    return generateStaticFiles();
  },
};

export default normalTemplate;
